import React, { FC } from 'react';

import { Box, Stack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { ScanTypes } from 'services/Vulnerability/types';
import { useVulnerabilityResourceScan } from 'services/Vulnerability/useVulnerabilityResourceService';

import { TableColumnProps } from 'components/DataDisplay/NewTable/types';
import { ResourceInfoTable } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/ResourceInfoTable';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';

export const VMCredentials: FC = () => {
  const { resourceId } = useActiveResourceContext();
  const { resourceUuid } = useSelector(selectActiveResource);
  const { instanceScanById } = useVulnerabilityResourceScan(
    resourceId,
    ScanTypes.Secrets,
    resourceUuid,
  );

  const columns: TableColumnProps[] = [
    { header: 'TYPE', accessor: 'title' },
    { header: 'PATH', accessor: 'target', align: 'left' },
    { header: 'CREATED AT', render: () => '-' },
    { header: 'LAST MODIFIED', render: () => '-' },
  ];

  return (
    <Stack w={'full'} h={'full'} pb={5} spacing={5}>
      <Box flex={1} minH={'300px'}>
        <ResourceInfoTable
          header={'PRIVATE CREDENTIALS'}
          columns={columns}
          data={instanceScanById.data?.secrets ?? []}
          totalCount={instanceScanById.data?.secrets?.length}
          isLoading={instanceScanById.isLoading}
        />
      </Box>
    </Stack>
  );
};
